import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  List,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/DialogHeader";
import { GeracaoRelatorioError } from "../types";
import {
  formatDateAndHour,
  formatDateRequest,
  getDayMonthAndYearFromDate,
} from "../../../main/utils/utils";
import { CardIntervalOptionsEnum } from "../../dashboard/types";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function ReportErrorsModal(props: {
  setOpen: (open: boolean) => void;
  open: boolean;
  errors: GeracaoRelatorioError[];
  usinaName: string;
}) {
  const { open, setOpen, errors, usinaName } = props;
  const onClose = () => setOpen(false);
  const referenceError = errors[0];
  const reportType = referenceError?.interval;
  const referenceDate = getDisplayableDateByDateAndReportType(
    referenceError?.referenceDate,
    reportType
  );
  const reportLabel = getLabelByCardIntervalOptionsEnum(reportType);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "500px",
          maxHeight: "600px",
        },
      }}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        <Typography
          sx={{
            fontSize: {
              xs: "1rem",
              sm: "1.5rem",
            },
            fontWeight: 500,
          }}
        >
          Erros na geração do relatório
        </Typography>
      </DialogHeader>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflowY: "auto",
        }}
        dividers
      >
        <Typography>
          Erros no relatorio {reportLabel} de {referenceDate}, da usina{" "}
          {usinaName}.
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: "8px",
          }}
        >
          <List sx={{ width: "100%" }}>
            {errors.map((error, index) => (
              <Box width="100%" key={index}>
                {index > 0 && <Divider sx={{ backgroundColor: "#FFFFFF" }} />}
                <Box
                  width="100%"
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                >
                  <ListItemText
                    primary={<>{error.message}</>}
                    secondary={
                      <>
                        <Typography>
                          Horário:{" "}
                          {formatDateAndHour(error.date) ?? "Não informado"}
                        </Typography>
                      </>
                    }
                  />
                  <Tooltip title="Copiar Detalhe Técnico" placement="top">
                    <IconButton
                      color="inherit"
                      onClick={() => {
                        navigator.clipboard.writeText(
                          getErrorLabelByError(error)
                        );
                      }}
                      sx={{ padding: "5px" }}
                    >
                      <ContentCopyIcon
                        style={{
                          transition: "transform 0.3s ease-in-out",
                          color: "#656C72",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            ))}
          </List>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            onClose();
          }}
        >
          {"Fechar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function getDisplayableDateByDateAndReportType(
  date: Date,
  reportType: CardIntervalOptionsEnum
): string {
  const referenceDate = getDayMonthAndYearFromDate(date);
  switch (reportType) {
    case CardIntervalOptionsEnum.Dia:
      return formatDateRequest(date);
    case CardIntervalOptionsEnum.Mes:
      return `${referenceDate.mes}/${referenceDate.ano}`;
    default:
      return formatDateRequest(date);
  }
}

function getLabelByCardIntervalOptionsEnum(interval: CardIntervalOptionsEnum) {
  switch (interval) {
    case CardIntervalOptionsEnum.Dia:
      return "diário";
    case CardIntervalOptionsEnum.Mes:
      return "mensal";
    default:
      return "";
  }
}

function getErrorLabelByError(error: GeracaoRelatorioError) {
  return `ExceptionMessage: ${error.message}\n\nStackTrace: ${error.stackTrace}`;
}
